import '../../utils/assertions.es.js';
import { maestroComponent } from '../../utils/componentHelpers.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'react';
import styled from 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Box } from '../Box/Box.es.js';
var StyledHidden = styled(Box).attrs(function (_ref) {
  var isVisible = _ref.isVisible;
  return {
    hidden: !isVisible
  };
}).withConfig({
  componentId: "sc-2486pp-0"
})([""]);
var Hidden = maestroComponent("Hidden", StyledHidden);
Hidden.defaultProps = {
  isVisible: false
};
export { Hidden };